<template>
  <div style="display: flex;justify-content: space-between">
    <div style="width: 75%;margin-right: 0.5rem">
      <DropDown
        v-model="computedModelValue"
        :options="options"
        :placeholder="translate('placeholder.no.filter')"
        appendTo="body"
        class="p-column-filter"
        optionLabel="label"
        showClear
        styleClass="ui-column-filter"
      >
        <template #value="slotProps">
          <div v-if="slotProps.value" class="p-dropdown-car-value">
            <span v-html="slotProps.value.label"></span>
          </div>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </template>
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <div
              style="display: flex;justify-content: space-between;width:100%"
            >
              <div v-html="slotProps.option.label"></div>
            </div>
          </div>
        </template>
      </DropDown>
    </div>
    <div style="display: flex;justify-content:space-between">
      <div
        style="display: flex;flex-direction: column;justify-content: center;height: 100%"
      >
        <Checkbox
          @change="handleFirstUSageSelect"
          :disabled="
            !computedModelValue || computedModelValue.key === 'NOT_AVAILABLE'
          "
          style="margin-right: 0.5rem"
          binary
          v-model="firstUsageCheck"
        ></Checkbox>
      </div>
      <div
        style="display: flex;flex-direction: column;justify-content: center;height: 100%"
      >
        <div style="text-overflow: ellipsis;white-space: nowrap">
          <i title="first usage" class="pi pi-check"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TranslateService from "@/services/translate.service";

export default {
  name: "FirstUsageDropDown",
  props: {
    value: null
  },
  watch: {
    // options:{
    //   handler(nv){
    //     checkOnly
    //   }
    // }
  },
  data() {
    return {
      firstUsageCheck: false,
      options: [
        {
          id: "AVAILABLE",
          key: "AVAILABLE",
          label: "Available"
        },
        { id: "TBA", key: "TBA", label: "TBA" },
        { id: "NOT_AVAILABLE", key: "NOT_AVAILABLE", label: "not Available" }
      ]
    };
  },
  computed: {
    computedModelValue: {
      get() {
        if (this.value && Array.isArray(this.value) && this.value.length > 0) {
          return this.value[0];
        }
        return this.value;
      },
      set(nv) {
        this.firstUsageCheck = nv === this.value;
        this.$emit("input", nv);
      }
    }
  },
  methods: {
    handleFirstUSageSelect() {
      if (this.firstUsageCheck) {
        const update = [this.computedModelValue];
        update.push({ key: "VIRGIN" });
        this.$emit("input", update);
      } else {
        const update = this.value[0];
        this.$emit("input", update);
      }
    },
    translate(message) {
      return TranslateService.translateMessage(message);
    }
  }
};
</script>

<style scoped></style>
